<template>
  <ScaleBox>
    <div class="mr-visual">
      <v-header-box></v-header-box>
      <transition name="el-fade-in-linear">
        <div class="mr-visual-container">
          <div class="power-analysis">
            <div style="margin-top:5px;">
              <el-form :inline="true" :model="searchParams">
                <el-form-item>
                  <template slot="label">
                    <span class="custom-label">统计周期</span>
                  </template>
                  <el-select v-model="searchParams.dataType" style="width:100px;margin-right:20px;" @change="changeType">
                    <el-option label="时" value="hour" />
                    <el-option label="日" value="day" />
                    <el-option label="周" value="week" />
                    <el-option label="月" value="month" />
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <template slot="label">
                    <span class="custom-label">能耗电表</span>
                  </template>
                  <el-select v-model="searchParams.deviceId" style="width:200px;margin-right:20px;" placeholder="请选择电表" @change="goSearch">
                      <el-option v-for="item in deviceList" :key="item.deviceId" :label="item.deviceName" :value="item.deviceId"/>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <template slot="label">
                    <span class="custom-label">日期范围</span>
                  </template>
                  <el-date-picker type="daterange" placeholder="选择日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd" v-model="searchParams.createdAt" style="width: 300px" clearable @change="goSearch"/>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="goSearch" style="width:80px;margin-left:20px;background-color:black;border-color:rgba(31, 51, 89, 1);">搜 索</el-button>
                  <el-button type="primary" @click="goExport" style="width:80px;margin-left:20px;background-color:black;border-color:rgba(31, 51, 89, 1);">导 出</el-button>
                </el-form-item>
              </el-form>
            </div>
            <el-table v-if="searchParams.dataType=='hour'" class="dark-table" height="400" :data="hourData" :tableConfig="tableConfig" :cell-style="cellStyle">
              <el-table-column label="统计时段" align="left" width="120" :formatter="formatDate"/>
              <el-table-column prop="period" label="时段类型" width="100" align="left">
                <template slot-scope="scope">
                  <span v-if="scope.row.period == 'jian'">尖</span>
                  <span v-if="scope.row.period == 'feng'">峰</span>
                  <span v-if="scope.row.period == 'gu'">谷</span>
                  <span v-if="scope.row.period == 'ping'">平</span>
                  <span v-if="scope.row.period == 'shen'">深谷</span>
                </template>
              </el-table-column>
              <el-table-column prop="hours" label="采集时段" align="center" width="100"/>
              <el-table-column prop="consume" label="消耗电量" align="left" width="120" />
              <el-table-column prop="pvalue" label="上次数据" align="left" width="100"/>
              <el-table-column prop="ptime" label="上次采集" align="left" width="180"/>
              <el-table-column prop="dvalue" label="本次数据" align="left" width="100"/>
              <el-table-column prop="dtime" label="本次采集" align="left" width="180"/>
              <el-table-column prop="price" label="参考电价" align="left" width="120"/>
              <el-table-column prop="deviceName" label="电表名称" align="left" width="180"/>
            </el-table>
            <el-table v-if="searchParams.dataType!='hour'" class="dark-table" height="400" :data="staticData" :tableConfig="tableConfig" :cell-style="cellStyle">
              <el-table-column prop="dataLabel" label="统计日期" align="left" width="120"/>
              <el-table-column prop="energyJian" label="尖时段电量" align="left" width="120"/>
              <el-table-column prop="energyFeng" label="峰时段电量" align="left" width="120"/>
              <el-table-column prop="energyPing" label="平时段电量" align="left" width="120"/>
              <el-table-column prop="energyGu" label="谷时段电量" align="left" width="120"/>
              <el-table-column prop="energyTotal" label="总计电量" align="left" width="100"/>
              <el-table-column prop="moneyJian" label="尖时段电费" align="left" width="120"/>
              <el-table-column prop="moneyFeng" label="峰时段电费" align="left" width="120"/>
              <el-table-column prop="moneyPing" label="平时段电费" align="left" width="120"/>
              <el-table-column prop="moneyGu" label="谷时段电费" align="left" width="120"/>
              <el-table-column prop="moneyTotal" label="总计电费" align="left" width="100"/>
              <el-table-column prop="dataType" label="数据类型" width="100" align="left">
                <template slot-scope="scope">
                  <span v-if="scope.row.dataType == 'day'">日</span>
                  <span v-if="scope.row.dataType == 'week'">周</span>
                  <span v-if="scope.row.dataType == 'month'">月</span>
                  <span v-if="scope.row.dataType == 'year'">年</span>
                </template>
              </el-table-column>
              <el-table-column prop="deviceName" label="电表名称" align="left" width="180"/>
            </el-table>
            <ECharts :options="energyOption" class="chart"/>
          </div>
        </div>
      </transition>
      <div class="mr-visual-footer">
        <v-footer></v-footer>
      </div>
    </div>
  </ScaleBox>
</template>

<script lang="js">
import { mapState } from "vuex";
import DiluTable from "@/components/public/dilu-table.vue";
import VHeaderBox from "./components/v-header-box.vue";
import VFooter from "./components/v-footer.vue";
import ScaleBox from "@/components/view/scaleBox.vue";
import ECharts from '@/components/view/ECharts.vue';
import { DateToShort } from "@/utils/util/util";

export default {
  name: 'visual',
  components: {
    VHeaderBox,
    VFooter,
    ScaleBox,
    ECharts,
    DiluTable
  },
  data() {
    return {
      energyOption: {},
      searchParams: {
        project: null,
        deviceId: null,
        dataType: "hour",
        createdAt: []
      },
      tableConfig: {
        isTree: false,
        isPage: false,   
      },
      deviceList: [],
      projectInfo: {},
      hourData: [],
      staticData: [],
      series: [],
    }
  },
  computed: {
    ...mapState(["projectCurrentRowData"])
  },
  mounted() {
    this.projectInfo=this.projectCurrentRowData || {};
    this.searchParams.project=this.projectInfo.projectCode;
    this.searchParams.createdAt=[DateToShort(new Date()),DateToShort(new Date())];
    this.initChartOption();
    this.loadDevice();
  },
  methods: {
    changeType() {
      const currentDate = new Date();
      if (this.searchParams.dataType=='hour') {
        this.searchParams.createdAt=[DateToShort(currentDate),DateToShort(currentDate)];
      } else if (this.searchParams.dataType=='day') {
        const date30DaysAgo = new Date();
        date30DaysAgo.setDate(currentDate.getDate() - 30);
        this.searchParams.createdAt=[DateToShort(date30DaysAgo),DateToShort(currentDate)];
      } else if (this.searchParams.dataType=='week') {
        const date90DaysAgo = new Date();
        date90DaysAgo.setDate(currentDate.getDate() - 90);
        this.searchParams.createdAt=[DateToShort(date90DaysAgo),DateToShort(currentDate)];
      } else if (this.searchParams.dataType=='month') {
        const date365DaysAgo = new Date();
        date365DaysAgo.setDate(currentDate.getDate() - 365);
        this.searchParams.createdAt=[DateToShort(date365DaysAgo),DateToShort(currentDate)];
      }
      this.goSearch();
    },
    formatDate(row) {
      if (row.ptime!=undefined&&row.ptime.length>=16) {
          return row.ptime.substring(11,16)+'~'+row.dtime.substring(11,16);
      } else {
        return row.dtime.substring(11,16);
      }
    },
    loadDevice() {
      this.request.deviceMeters({project:this.searchParams.project}).then((res) => {
        if (res.code == 0) {
          this.deviceList=res.data;
          if (this.deviceList.length>0) {
            this.searchParams.deviceId=this.deviceList[0].deviceId;
            this.searchParams.dataType='hour';
            this.goSearch();
          }
        }
      });
    },
    goExport() {
      const that = this;
      this.request.energyExport(that.searchParams).then((res) => {
        if (!res || !res.data) {
          that.$message({
            type: "error",
            message: "下载失败",
          });
        } else if (res.data.size < 100) {
          var reader = new FileReader();
          reader.onload = function () {
            var json = JSON.parse(reader.result);
            that.$message({
              type: "error",
              message: json.msg,
            });
          };
          reader.readAsText(new Blob([res.data]));
        } else {
          const blob = new Blob([res.data], {
            type: "application/vnd.ms-excel",
          });
          const filename = res.headers["content-disposition"]
            .split(";")[1]
            .split("filename=")[1];
          if ("download" in document.createElement("a")) {
            // 非IE下载
            const link = document.createElement("a");
            const blob = new Blob([res.data], {
              type: "application/vnd.ms-excel",
            });
            link.style.display = "none";
            link.href = URL.createObjectURL(blob);
            link.setAttribute("download", decodeURIComponent(filename));
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } else {
            // IE10+下载
            navigator.msSaveBlob(blob, decodeURIComponent(filename));
          }
        }
      });
    },
    goSearch() {
      const that=this;
      if (that.searchParams.dataType=='hour') {
        this.request.hourEnergy(this.searchParams).then((res) => {
          if (res.code == 0) {
            this.hourData=res.data;
            var data=[];
            for (var i=0; i<this.hourData.length; i++) {
              data.push({"value":[this.hourData[i].hours,this.hourData[i].consume]});
            }
            this.series=[
              {
                "data": data,
                "type": "line",
                "name": "小时能耗（kW·h）",
                "smooth": true,
                areaStyle: {
                  color: {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [{
                      offset: 0, color: 'rgba(64, 158, 255, 0.8)'
                    }, {
                      offset: 1, color: 'rgba(64, 158, 255, 0.1)'
                    }]
                  }
                }
              }
            ];
            this.initChartOption();
          }
        });
      } else {
        this.request.staticEnergy(this.searchParams).then((res) => {
          if (res.code == 0) {
            this.staticData=res.data;
            var totalData=[];
            var jianData=[];
            var fengData=[];
            var pingData=[];
            var guData=[];
            for (var i=0; i<this.staticData.length; i++) {
              totalData.push({"value":[this.staticData[i].dataLabel,this.staticData[i].energyTotal]});
              jianData.push({"value":[this.staticData[i].dataLabel,this.staticData[i].energyJian]});
              fengData.push({"value":[this.staticData[i].dataLabel,this.staticData[i].energyFeng]});
              pingData.push({"value":[this.staticData[i].dataLabel,this.staticData[i].energyGu]});
              guData.push({"value":[this.staticData[i].dataLabel,this.staticData[i].energyPing]});
            }
            var totalLabel="";
            var jianLabel="";
            var fengLabel="";
            var pingLabel="";
            var guLabel="";
             if (this.searchParams.dataType=='day') {
              totalLabel='日总能耗（kW·h）';
              jianLabel="尖时段（kW·h）";
              fengLabel="峰时段（kW·h）";
              pingLabel="平时段（kW·h）";
              guLabel="谷时段（kW·h）";
            } else if (this.searchParams.dataType=='week') {
              totalLabel='周总能耗（kW·h）';
              jianLabel="尖时段（kW·h）";
              fengLabel="峰时段（kW·h）";
              pingLabel="平时段（kW·h）";
              guLabel="谷时段（kW·h）";
            } else if (this.searchParams.dataType=='month') {
              totalLabel='月总能耗（kW·h）';
              jianLabel="尖时段（kW·h）";
              fengLabel="峰时段（kW·h）";
              pingLabel="平时段（kW·h）";
              guLabel="谷时段（kW·h）";
            }
            this.series=[
              {
                "data": totalData,
                "type": "line",
                "name": totalLabel,
                "smooth": true,
              },
              {
                "data": jianData,
                "type": "line",
                "name": jianLabel,
                "smooth": true,
              },
              {
                "data": fengData,
                "type": "line",
                "name": fengLabel,
                "smooth": true,
              },
              {
                "data": pingData,
                "type": "line",
                "name": pingLabel,
                "smooth": true,
              },
              {
                "data": guData,
                "type": "line",
                "name": guLabel,
                "smooth": true,
              },
            ];
            this.initChartOption();
          }
        });
      }
    },
    initChartOption() {
      if (this.energyOption.series!=null&&this.energyOption.series.length>0) {
        this.energyOption.series.splice(0,this.energyOption.series.length);
      }
      this.energyOption = {
        xAxis: {
          type: "category",
          boundaryGap: false,
          axisLabel: { color: '#ffffff' },
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: false,
          },
          axisLine: {
            show: true,
          },
          axisLabel: { color: '#ffffff' },
        },
        legend: {
          show: true,
          textStyle: { color: '#ffffff' },
        },
        tooltip: {
          trigger: "axis",
        },
        grid: {
          left: 60,
          right: 20,
          top: 30,
          bottom: 30,
        },
        series: this.series,
      };
    },
    cellStyle() {
      return {
          fontSize: '16px'
      };
    }
  }
}
</script>

<style lang="scss">

/* 在现有样式基础上补充 */
::v-deep .dark-table {
  /* 彻底去除表格外层所有可能的边框线 */
  border: none !important;
}

/* 处理表格内部容器的伪元素边框 */
::v-deep .dark-table .el-table__inner-wrapper::before,
::v-deep .dark-table .el-table__inner-wrapper::after {
  display: none !important;
}

/* 处理表格单元格的边框（包括最后一行） */
::v-deep .dark-table .el-table__body tr:last-child td.el-table__cell {
  border-bottom: none !important;
}

/* 处理表格空状态时的边框 */
::v-deep .dark-table .el-table__empty-block {
  border: none !important;
}

.el-table::before {
  height: 1px;
  background-color: rgba(31, 51, 89, 1);
}

.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf {
  border-bottom: none;
}

/* 表格整体黑色背景 */
.dark-table {
  background-color: #000 !important;
}

/* 表头样式 - 深灰色背景，白色文字 */
.dark-table .el-table__header-wrapper,
.dark-table .el-table__header th {
  background-color: #222 !important;
}

.dark-table .el-table__header th .cell {
  color: white !important;
  font-weight: bold;
}

/* 表格内容 - 黑色背景，白色文字 */
.dark-table .el-table__body,
.dark-table .el-table__body td {
  background-color: #000 !important;
  color: white !important;
  border-bottom: none !important;
}


.el-table td.el-table__cell {
    border-bottom: none !important;
}

.el-table {
    border-bottom: none !important;
}

.dark-table .el-table::before {
  background-color: #000 !important;
}

.dark-table .el-table__body-wrapper::after,
.dark-table .el-table__header-wrapper::after {
  background-color: #000 !important;
}

/* 去除表格底部边框线 */
.dark-table .el-table__body-wrapper {
  border-bottom: none !important;
}

/* 去除表格底部外边框 */
.dark-table .el-table {
  border-bottom: none !important;
}

/* 处理表格::after伪元素的边框线 */
.dark-table .el-table::after {
  display: none !important;
}

/* 处理表格::before伪元素的边框线 */
.dark-table .el-table::before {
  display: none !important;
}

</style>

<style scoped lang="scss">

::v-deep .el-input__inner {
  background-color: rgba(31, 51, 89, 0.4) !important; 
  color: #ffffff !important;
  border-color: rgba(31, 51, 89, 1);
}

::v-deep .el-range-editor .el-range-input {
  background-color: rgba(31, 51, 89, 0.4) !important; 
  color: #ffffff !important;
  border-color: rgba(31, 51, 89, 1);
}

.custom-label {
  color: #ffffff;
}

.mr-visual {
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 1);
  overflow: hidden;
  position: relative;

  .mr-visual-header {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1000;
    background: linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0) 100%);
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
  }

  .mr-visual-container {
    position: absolute;
    opacity: 1;
    box-sizing: border-box;
    .scroll {
      height: 100%;
      >div {
        margin-bottom: 8px;
      }
    }
  }

  .mr-visual-container {
    width: 100%;
    top: 70px;
    margin: auto;
  }

  .mr-visual-footer {
    width: 100%;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    text-align: center;
  }

}

.chart {
  width: 96%;
  height: 200px;
  margin-top: 10px;
  background-color: black;
}

.power-analysis {
  margin: 10px;
  padding: 10px;
}

</style>
